<template>
  <div class="ExportEvent">
    <b-container>
      <b-button class="back" variant="primary" @click="back">Back</b-button>
      <b-row>
        <b-col>
          <h2>INVOICE # {{ this.exportEvent.invoice_number }}</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p>{{this.exportEvent.invoice_date}}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <p><strong>Sale Staff:</strong> {{ this.exportEvent.sales.name }}</p>
        </b-col>
        <b-col cols="6">
          <p><strong>Installation Staff:</strong> {{ this.exportEvent.installation_staff.name }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <p><strong>Store Location:</strong> {{ this.exportEvent.store_location }}</p>
        </b-col>
        <b-col v-if="this.exportEvent.type == 'installation'" cols="6">
          <p><strong>Job Style:</strong> {{ this.exportEvent.job_style }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="this.exportEvent.type == 'installation'" cols="6">
          <p><strong>Cemetery:</strong> {{ this.exportEvent.cemetery }}</p>
        </b-col>
        <b-col cols="6">
          <p><strong>Full Monument Due:</strong> {{ this.exportEvent.due_date }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="this.exportEvent.type == 'installation' && this.exportEvent.ashlar_due.length != 0" cols="6">
          <p><strong>Ashlars Due:</strong> {{ this.exportEvent.ashlarDue }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="this.exportEvent.type == 'installation'" cols="12">
          <p><strong>Speical Request:</strong> </p>
          <p>{{ this.exportEvent.taskDetail }}</p>
        </b-col>
        <b-col v-if="this.exportEvent.type == 'small task'" cols="12">
          <p><strong>Job Description:</strong> </p>
          <p>{{ this.exportEvent.taskDetail }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-table v-if="this.exportEvent.type == 'installation'" striped :items="checklist_items" :fields="checklist_fields"></b-table>
        <b-table v-if="this.exportEvent.type == 'small task'" striped :items="subtasks_items" :fields="subtasks_fields"></b-table>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'ExportEvent',
  data() {
    return {
      header: '',
      lead: '',
      subtasks_fields: [{key: 'id', label: '#'}, {key: 'task_name', label: "Task Name"}, {key: 'due_date', label: 'Due date'}],
      subtasks_items: this.exportEvent.subtasks,
      checklist_fields: [{key: 'id', label: '#'}, 'requirement', {key: 'sales_tick', label: "Sales Use"}, {key: 'installation_tick', label: 'Installation Use'}],
      checklist_items: [
        {
          id: 1,
          requirement: 'Ashlars',
          sales_tick: this.exportEvent.sales_checklist.checkAshlars == 'true'? 'Required' : '',
        },
        {
          id: 2,
          requirement: 'Monument',
          sales_tick: this.exportEvent.sales_checklist.checkMonument == 'true'? 'Required' : '',
        },
        {
          id: 3,
          requirement: 'Photo & Frames',
          sales_tick: this.exportEvent.sales_checklist.checkPhotosAFrames == 'true'? 'Required' : '',
        },
        {
          id: 4,
          requirement: 'Candle box & Door',
          sales_tick: this.exportEvent.sales_checklist.checkCandleBoxADoor == 'true'? 'Required' : '',
        },
        {
          id: 5,
          requirement: 'Headstone Door',
          sales_tick: this.exportEvent.sales_checklist.checkHeadstone == 'true'? 'Required' : '',
        },
        {
          id: 6,
          requirement: 'Kerb Door',
          sales_tick: this.exportEvent.sales_checklist.checkKerb == 'true'? 'Required' : '',
        },
        {
          id: 7,
          requirement: 'Cabinet Door',
          sales_tick: this.exportEvent.sales_checklist.checkCabinetDoor == 'true'? 'Required' : '',
        },
        {
          id: 8,
          requirement: 'Book & Wedge',
          sales_tick: this.exportEvent.sales_checklist.checkBookAWedge == 'true'? 'Required' : '',
        },
        {
          id: 9,
          requirement: 'Vase & Flower box',
          sales_tick: this.exportEvent.sales_checklist.checkVaseAFlowerBox == 'true'? 'Required' : '',
        },
        {
          id: 10,
          requirement: 'Religious Statue',
          sales_tick: this.exportEvent.sales_checklist.checkReligiousStatue == 'true'? 'Required' : '',
        },
        {
          id: 11,
          requirement: 'Lantern',
          sales_tick: this.exportEvent.sales_checklist.checkLantern == 'true'? 'Required' : '',
        },
        {
          id: 12,
          requirement: 'Cross',
          sales_tick: this.exportEvent.sales_checklist.checkCross == 'true'? 'Required' : '',
        },
        {
          id: 13,
          requirement: 'Lions',
          sales_tick: this.exportEvent.sales_checklist.checkLions == 'true'? 'Required' : '',
        },
        {
          id: 14,
          requirement: 'Soil & Pebble',
          sales_tick: this.exportEvent.sales_checklist.checkSoilAPebble == 'true'? 'Required' : '',
        },
        {
          id: 15,
          requirement: 'Cement Use (Peter/John Use Only) (Even edge & No leaking)',
          installation_tick: this.exportEvent.installation_staff_checklist.checkCementUse == 'true'? 'Required' : '',
        },
        {
          id: 16,
          requirement: 'Dowels (Peter/John Use Only) (Must meet Cemetery Specification)',
          installation_tick: this.exportEvent.installation_staff_checklist.checkDowels == 'true'? 'Required' : '',
        },
        {
          id: 17,
          requirement: 'Silicone Apply (Peter/John Use Only)',
          installation_tick: this.exportEvent.installation_staff_checklist.checkSilicone == 'true'? 'Required' : '',
        },
        {
          id: 18,
          requirement: 'Clean (Peter/John Use Only)',
          installation_tick: this.exportEvent.installation_staff_checklist.checkClean == 'true'? 'Required' : '',
        },
        {
          id: 19,
          requirement: 'Others',
          installation_tick: this.exportEvent.installation_staff_checklist.checkOthers == 'true'? 'Required' : '',
        },
      ]
    }
  },
  props: {
    user: Object,
    exportEvent: Object,
  },
  mounted() {
    this.header = 'INVOICE # ' + this.exportEvent.invoice_number;
    console.log(this.exportEvent.installation_staff_checklist);
    console.log(this.exportEvent.sales_checklist);
  },
  methods: {
    back() {
      this.$emit('backToEventDetail', this.exportEvent);
    }
  }
}
</script>

<style scoped>
@media print {
  .back {
    visibility: hidden;
  }
}
</style>